<template>
  <div class="flex items-end">
    <strong
      :style="{
        fontSize: props.size + 'px',
      }"
      style="color: #333"
    >
      {{ props.value1 }}
    </strong>
    <text
      class="text-gray-400"
      :style="{
        fontSize: props.size * 0.8 + 'px',
      }"
    >
      {{ "/" + props.value2 }}
    </text>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    value1: String,
    value2: String,
    size: {
      type: Number,
      default: 13,
    },
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
